import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase'; // Adjust path
import { useAuth } from '../context/AuthContext'; // Optional: to add managedBy
import styles from '../styles/AddClientPage.module.css'; // Create this CSS file

const AddClientPage = () => {
    const navigate = useNavigate();
    const { currentUser } = useAuth(); // Get current user if needed
    // --- Form State ---
    const [name, setName] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [address, setAddress] = useState('');
    const [notes, setNotes] = useState('');
    // --- Helper State ---
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        // Basic validation (add more as needed)
        if (!name) {
            setError("Client name is required.");
            return;
        }
        setLoading(true);

        try {
            const clientsCol = collection(db, 'clients');
            await addDoc(clientsCol, {
                name,
                phoneNumber,
                address,
                notes,
                createdAt: serverTimestamp(),
                updatedAt: serverTimestamp(),
                // Optional: Assign the current user as the manager
                // managedBy: currentUser ? currentUser.uid : null
            });
            console.log("Client added successfully!");
            navigate('/clients'); // Redirect to client list after creation
        } catch (err) {
            console.error("Error adding client: ", err);
            setError('Failed to add client. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className={styles.pageContainer}>
            <div className={styles.formBox}>
                <h2 className={styles.formTitle}>Add New Client</h2>
                {error && <div className={styles.errorMessage}>{error}</div>}

                <form onSubmit={handleSubmit} className={styles.form}>
                    <div className={styles.inputGroup}>
                        <label htmlFor="name">Client Name</label>
                        <input
                            type="text"
                            id="name"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            required
                            disabled={loading}
                        />
                    </div>

                     <div className={styles.inputGroup}>
                        <label htmlFor="phoneNumber">Phone Number</label>
                        <input
                            type="tel" // Use type="tel" for phone numbers
                            id="phoneNumber"
                            value={phoneNumber}
                            onChange={(e) => setPhoneNumber(e.target.value)}
                            disabled={loading}
                        />
                    </div>

                     <div className={styles.inputGroup}>
                        <label htmlFor="address">Address</label>
                        <textarea
                            id="address"
                            value={address}
                            onChange={(e) => setAddress(e.target.value)}
                            rows={3}
                            disabled={loading}
                        />
                    </div>

                    <div className={styles.inputGroup}>
                        <label htmlFor="notes">Notes</label>
                        <textarea
                            id="notes"
                            value={notes}
                            onChange={(e) => setNotes(e.target.value)}
                            rows={5}
                            disabled={loading}
                        />
                    </div>

                    <div className={styles.buttonGroup}>
                        <button type="button" className={`${styles.formButton} ${styles.cancelButton}`} onClick={() => navigate('/clients')} disabled={loading}>
                            Cancel
                        </button>
                        <button type="submit" className={`${styles.formButton} ${styles.submitButton}`} disabled={loading}>
                            {loading ? <span className={styles.loadingSpinner}></span> : 'Add Client'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default AddClientPage;